import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Select from 'react-select'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appGetAllUser } from '../../store/user'
import { appJoinSanstha } from '../../store/sanstha'
import PostPreview from '../../components/PostPreview/PostPreview'

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	//console.log(hubId, permissionOfHub)

	const { users, isloder, paginate } = useSelector(state => state?.usersReducer)
	const sanstha = useSelector(state => state?.sansthaReducer.sanstha)
	const [page, setPage] = useState(params.page || 1)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({ hub: null })
	const [searchType, setSearchType] = useState('firstName')
	const [search, setSearch] = useState('')
	const [showUserModal, setShowUserModal] = useState(false)
	const [modalTitle, setModalTitle] = useState('')
	const [currentSansthaId, setCurrentSansthaId] = useState(null)
	const [selectedSanstha, setSelectedSanstha] = useState(null)

	useEffect(() => {
		if (hubId || permissionOfHub) {
			const searchParams = {
				...activeFilters,
				page,
				limit: 10,
				hub: hubId || permissionOfHub,
			}
			dispatch(appGetAllUser(searchParams))
			navigate(`/user/${page}`)
		}
	}, [page, activeFilters])

	const handleSearch = useCallback(() => {
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (search) {
			filters[searchType] = search
		}
		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters, search, searchType])

	const handleReset = () => {
		setSelectedFilters({
			hub: null,
		})
		setSearch('')
		setSearchType('firstName')
		setPage(1)
		setActiveFilters({})
		setExportFilters({})
	}

	const handleJoinSanstha = () => {
		if (selectedSanstha) {
			const payload = {
				userId: currentSansthaId,
				sansthaId: selectedSanstha.value,
			}
			//	console.log('Join Sanstha Payload:', payload)
			dispatch(appJoinSanstha(payload))

			setShowUserModal(false)
			setSelectedSanstha(null)
			setModalTitle('')
		}
	}

	const handleCloseModal = () => {
		setShowUserModal(false)
		setSelectedSanstha(null)
		setModalTitle('')
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row mb-3">
						<div className="col-12">
							<div className="d-flex align-items-end flex-wrap gap-3">
								<form
									className="flex-grow-1 container-md"
									onSubmit={e => {
										e.preventDefault()
										handleSearch()
									}}
								>
									<div className="input-group">
										<select
											className="form-control"
											value={searchType}
											onChange={e => setSearchType(e.target.value)}
										>
											<option value="firstName">First Name</option>
											<option value="lastName">Last Name</option>
											<option value="mobile">Mobile</option>
											<option value="email">Email</option>
											<option value="goutra">Goutra</option>
										</select>
										<input
											className="form-control"
											type="text"
											placeholder={`Search by ${searchType}...`}
											value={search}
											onChange={e => setSearch(e.target.value)}
										/>
										<div className="input-group-append">
											<button className="btn btn-info" type="submit">
												<em className="fas fa-search me-1"></em> Search
											</button>

											<button className="btn btn-secondary" type="button" onClick={handleReset}>
												<em className="fas fa-redo me-1"></em> Reset
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div className="table-responsive bootgrid mt-3">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>User</th>

									<th data-column-id="received" data-order="desc">
										Mobile
									</th>
									<th data-column-id="received" data-order="desc">
										Community
									</th>
									<th data-column-id="received" data-order="desc">
										Native Address
									</th>
									<th data-column-id="received" data-order="desc">
										Present Address
									</th>

									<th data-column-id="received" data-order="desc">
										Platform Joined Date
									</th>
									<th>Premium Member</th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							<tbody>
								{users && users.length > 0 ? (
									users.map((value, index) => (
										<tr
											key={index}
											onClick={e => {
												if (
													e.target.closest('td:last-child') ||
													e.target.closest('button') ||
													e.target.closest('.btn')
												) {
													return
												}
												navigate(`/user/details/${value?._id}`)
											}}
											style={{
												cursor: 'pointer',
												backgroundColor: value?.isUserBlocked ? '#ffe5e5' : '',
											}}
										>
											<td>
												<td>
													<PostPreview value={value?.profilePic || '/img/user.jpg'} />
													<br />
													{value.firstName} {value.lastName}
												</td>
											</td>
											<td>{value?.mobile}</td>
											<td>
												{value?.joinedHub?.name}
												<br />
												{value.joinedHubDate && (
													<small>
														Joined Date-
														{new Date(value.joinedHubDate).toLocaleDateString('en-US', {
															year: 'numeric',
															month: 'short',
															day: 'numeric',
														})}
													</small>
												)}
											</td>
											<td>
												{value?.nativePlaceAddress && value?.nativeArea && (
													<>
														{value?.nativePlaceAddress}, {value?.nativeArea}
													</>
												)}

												<br />
												{value?.nativeBlock &&
													value?.nativeDistrict &&
													value?.nativeState &&
													value?.nativePlacePincode && (
														<>
															<span>
																{' '}
																{value?.nativeBlock}, {value?.nativeDistrict} ,{value?.nativeState}{' '}
																{value?.nativePlacePincode}
															</span>
														</>
													)}
												<br />
											</td>
											<td>
												{value?.presentAddress && value?.presentnativeArea && (
													<>
														{value?.presentAddress}, {value?.presentnativeArea}
													</>
												)}
												<br />
												{value?.presentBlock &&
													value?.presentDistrict &&
													value?.presentState &&
													value?.presentPincode && (
														<>
															<span>
																{value?.presentBlock}, {value?.presentDistrict} ,
																{value?.presentState} {value?.presentPincode}
															</span>
														</>
													)}
											</td>

											<td>
												{value?.createdAt
													? new Date(value.createdAt).toLocaleDateString('en-US', {
															year: 'numeric',
															month: 'short',
															day: 'numeric',
															hour: '2-digit',
															minute: '2-digit',
													  })
													: '-'}
											</td>
											<td>
												{value?.premium === true ? (
													<span className="badge badge-primary">Premium Membership</span>
												) : null}
											</td>
											<td>
												<div className="btn-group" style={{ position: 'absolute' }}>
													<button
														className="btn btn-link"
														data-toggle="dropdown"
														aria-expanded="false"
														style={{
															position: 'relative',
															zIndex: 1,
															padding: '0px',
														}}
													>
														<em className="fa fa-ellipsis-v fa-lg"></em>
													</button>
													<div
														className="dropdown-menu dropdown-menu-right-forced animated fadeInLeft"
														role="menu"
														x-placement="bottom-start"
														style={{
															position: 'relative',
															top: '100%',
															left: '0',
															zIndex: 1000,
															minWidth: '200px',
															marginTop: '5px',
															maxHeight: 'fit-content',
															boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
															overflow: 'visible',
														}}
													>
														<a
															className="dropdown-item"
															href=""
															onClick={() => navigate(`/user/details/${value?._id}`)}
														>
															<em className="fa fa-eye fa-fw"></em>
															<span> Details</span>
														</a>
													</div>
												</div>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan="8" className="text-center py-4">
											<div className="d-flex flex-column align-items-center">
												<h5 className="text-muted">No Records Found</h5>
											</div>
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>

			{showUserModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						top: '50px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{modalTitle}</h5>
								<button type="button" className="close" onClick={handleCloseModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="form-group">
									<label>Select Sanstha</label>
									<Select
										options={
											Array.isArray(sanstha)
												? sanstha
														.filter(
															s =>
																s.hub &&
																s.hub._id ===
																	users.find(u => u._id === currentSansthaId)?.joinedHub?._id,
														)
														.map(s => ({
															value: s._id,
															label: s.name,
														}))
												: []
										}
										onChange={setSelectedSanstha}
										value={selectedSanstha}
										placeholder="Select Sanstha..."
										getOptionLabel={option => option?.name || option?.label}
										getOptionValue={option => option?._id || option?.value}
										filterOption={(option, inputValue) => {
											const label = option?.label || ''
											const input = inputValue.toLowerCase()
											return label.toLowerCase().includes(input)
										}}
									/>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
									Cancel
								</button>
								<button type="button" className="btn btn-primary" onClick={handleJoinSanstha}>
									{modalTitle}
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
